<div class="row">
    <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #exclusionMapGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    [autoSize]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.customerCarrierExclusionMapID)"><i class="fas fa-pencil-alt"></i></button>
                    <button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.customerCarrierExclusionMapID)"><i class="fas fa-times"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="customerCode" title="Customer 3x3"></kendo-grid-column>
            <kendo-grid-column field="customerName" title="Customer"></kendo-grid-column>
            <kendo-grid-column field="createdDate" title="Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.createdDate | date: 'M/dd/yyyy'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="notes" title="Notes"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isEdit || isAdd">
        <!-- Edit Customer Exclusion form -->
        <carrier-customer-exclusion-form [customerCarrierExclusionMapID]="customerCarrierExclusionMapID" [carrierID]="carrierID" (onRefresh)="cancelEdit()"></carrier-customer-exclusion-form>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
